module.exports = __webpack_public_path__ + "img/branchs-combined.194dbf71.png";